import SignIn from "@/views/mixins/sign-in"

export default {
    mixins: [SignIn],
    components: {},
    data() {
        return {
            show_login:true,
            tab_index: 0,
            menus: [
                '首页', '加入会议', '软件下载', '帮助'
            ],
            manuals: [],
            tencent_downloads: [
                {
                    id: 1,
                    title: 'macOS',
                    icon: 'https://cdn.meeting.tencent.com/assets/configurable-website/packages/meeting-public/download/def_macos.png'
                },
                {
                    id: 2,
                    title: 'Windows',
                    icon: 'https://cdn.meeting.tencent.com/assets/configurable-website/packages/meeting-public/download/def_windows.png'
                },
                {
                    id: 3,
                    title: 'Linux',
                    icon: 'https://cdn.meeting.tencent.com/assets/configurable-website/packages/meeting-public/download/linux.png'
                },
                {
                    id: 4,
                    title: 'Outlook插件',
                    icon: 'https://cdn.meeting.tencent.com/assets/configurable-website/packages/meeting-public/download/outlook.png'
                },
            ],
            meeting_number: '',
            slogan: ['支持师生与海内外合作，开展远程视频教学培训，举办远程视频会议及交流。',
                '通过简单易用的会议客户端操作，提供音视频沟通及数据共享方案。',
                '支持超大容量，高清画质，支持多终端，多系统以及传统音视频设备。'],
            icons: [
                {icon: "feature-1", subject: '移动', title: "支持手机和平板参会，随时随地发起会议，支持手机共享屏幕和图片"},
                {icon: "feature-2", subject: '易用', title: "简单明了、方便快捷，OA创会，系统收集录像和参会记录，一键下载"},
                {icon: "feature-3", subject: '协作', title: "自由灵活分享屏幕，支持聊天、分组讨论，投票，同传，标注、直播、电子白板和影音分享"},
                {icon: "feature-4", subject: '安全', title: "私有化系统部署，SSO对接登录、等候室，锁定会议等手段提供会议信息安全"},
            ]
        }
    },
    created() {
        this.getManuals();
        if (this.$route.query.help) {
            this.tab_index = 3;
        }
    },
    methods: {
        handleCommand(cmd){
            if (cmd === "sso") {
                this.jumpToOAuth2();
            } else {
                this.show_login = true;
            }
        },
        joinTencentMeeting() {
            const url = "https://meeting.tencent.com/user-center/joining?meeting_code=" + this.meeting_number;
            window.open(url, "_blank");
        },
        getManuals() {
            this.$api('Admin.Manual.Manuals', {}, true).then(res => {
                this.manual = [];
                let divided = false;
                let old = "";
                res.data.data.forEach(item => {
                    item.extra_link = item.extra_link ? item.extra_link : "";
                    divided = (old === "" && item.extra_link !== "");
                    old = item.extra_link;
                    this.manuals.push({
                        icon: item.extra_link ? 'el-icon-link' : 'el-icon-document',
                        divided: divided,
                        name: item.name,
                        link: item.extra_link ? item.extra_link : item.link
                    });
                });
            });
        },
        handleTencentDownload() {
            window.open('https://meeting.tencent.com/download-center.html', '_blank');
        },
        handleVoovDownload() {
            window.open('https://voovmeeting.com/download-center.html', '_blank');
        }
    }
}
